import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  Switch,
  SWITCH_SIZES,
} from '@wetransfer/transfer/component/form/element/Switch/Switch';
import I18n from '@wetransfer/transfer/modules/i18n';
import Actions from '@wetransfer/transfer/store/action';

export default function ConsentManagerDataOptIn() {
  const dispatch = useDispatch();
  const [dataOptIn, setDataOptIn] = useState<boolean>();
  useEffect(() => {
    (async () => {
      const { data_opt_in } = await dispatch(Actions.User.getUserOccupation());

      if (data_opt_in !== null) {
        setDataOptIn(data_opt_in);
      }
    })();
  }, [dispatch]);

  useEffect(() => {
    dispatch(Actions.User.updateUserDataOptIn(dataOptIn));
  }, [dataOptIn, dispatch]);

  return (
    <>
      <h2>{I18n.t('account.consent_manager.data_opt_in.subtitle')}</h2>
      <p>{I18n.t('account.consent_manager.data_opt_in.p1')}</p>
      <p>{I18n.t('account.consent_manager.data_opt_in.p2')}</p>
      <p className="consent-manager__font-weight-700">
        {I18n.t('account.consent_manager.data_opt_in.p3')}
      </p>
      <p>{I18n.t('account.consent_manager.data_opt_in.p4')}</p>
      <span className="consent-manager__data-opt-in">
        <Switch
          key="data_opt_in"
          name="data_opt_in"
          checked={dataOptIn}
          onChange={() => setDataOptIn((dataOptIn) => !dataOptIn)}
          size={SWITCH_SIZES.SMALL}
        />
        <span className="consent-manager__data-opt-in-text">
          {I18n.t('account.consent_manager.data_opt_in.control_label')}
        </span>
      </span>
      <hr className="consent-manager__data-opt-in-hr" />
    </>
  );
}
